<div class="group-content">
  <ng-content select="[slot='content']"></ng-content>
</div>
